<!--22-客流量分析-->
<template>
  <div class="pm50">
    <div class="pd jhnstop row">
      <p class="col">
        <img src="../../assets/img/logo.png" class="loginnhjer cz" />
      </p>
      <span class="cf fz15" @click="toHome">首页</span>
    </div>
    <div>
      <van-dropdown-menu>
        <van-dropdown-item v-model="statInput.startDate" :options="option1" />
      </van-dropdown-menu>
    </div>
    <div>
      <div class="pd pt20">
        <p>
          <span class="jjnjjjert">门票渠道统计</span>
        </p>
        <div v-if="loading1">
          <van-loading class="loading" size="24px" type="spinner" vertical>加载中...</van-loading>
        </div>
        <div class="kmmmxeert" v-else-if="shuju.series[0].data.length > 0">
          <tubiao v-model="shuju"></tubiao>
        </div>
        <div v-else>
          <no-data :content-height="80"></no-data>
        </div>
      </div>
      <div class="pd pt20">
        <p>
          <span class="jjnjjjert">景点客流统计</span>
        </p>
      </div>
      <div v-if="loading2">
        <van-loading class="loading" size="24px" type="spinner" vertical>加载中...</van-loading>
      </div>
      <div class="kmmmxeert ab" v-else-if="shujub.series[0].data.length > 0">
        <tubiao v-model="shujub"></tubiao>
      </div>
      <div v-else>
        <no-data :content-height="80"></no-data>
      </div>
    </div>
  </div>
</template>
<script>
import tubiao from "@/components/tubiao";
import moment from "moment";
import ticketService from "@/services/ticketService.js";
import NoData from "@/components/NoData.vue";

export default {
  data() {
    return {
      loading1: false,
      loading2: false,
      statInput: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().add(1, "days").format("YYYY-MM-DD"),
      },
      option1: [
        {
          text: "今天",
          value: moment().format("YYYY-MM-DD")
        },
        // {
        //   text: "最近一周",
        //   value: moment()
        //   .subtract(1, "weeks")
        //   .format("YYYY-MM-DD")
        // },
        {
          text: "最近一个月",
          value: moment().subtract(1, "months").format("YYYY-MM-DD"),
        },
        {
          text: "最近二个月",
          value: moment().subtract(2, "months").format("YYYY-MM-DD"),
        },
        {
          text: "最近三个月",
          value: moment().subtract(3, "months").format("YYYY-MM-DD"),
        },
      ],
      shuju: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        series: [
          {
            name: "访问来源",
            type: "pie",

            radius: ["40%", "60%"],
            label: {
              formatter: "{b} {per|{d}%}",
              rich: {
                per: {
                  color: "#eee",
                  backgroundColor: "#603531",
                  padding: [2, 4],
                  borderRadius: 2,
                },
              },
            },
            // color: ["#3C8046", "#7F501E", "#3C7080", "#A9716D", "#6A8840"],
            //color: ["#A9716D", "#6A8840"],
            data: [
              // {
              //   value: 27,
              //   name: "官网预约",
              // },
              // {
              //   value: 30,
              //   name: "分销预约",
              // },
              // {
              //   value: 23,
              //   name: "窗口预约",
              // },
              // {
              //   value: 47,
              //   name: "自助机预约",
              // },
              // {
              //   value: 57,
              //   name: "微信预约",
              // },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      shujub: {
        color: ["#3C8046"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              //最外面的边框颜色
              lineStyle: {
                color: "#999999",
              },
            },
            axisLabel: {
              rotate: 45,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              //最外面的边框颜色
              lineStyle: {
                color: "#999999",
              },
            },
          },
        ],
        series: [
          {
            name: "直接访问",
            type: "bar",
            barWidth: "40%",
            label: {
              show: true,
              position: "insideRight",
            },
            data: [],
          },
        ],
      },
    };
  },
  components: {
    tubiao,
    NoData,
  },
  watch: {
    "statInput.startDate": function () {
      this.loadData();
    },
  },
  methods: {
    toHome() {
      this.$router.push("/");
    },
    loadData() {
      this.loading1 = true;
      this.loading2 = true;
      ticketService
        .statTicketCheckByTradeSourceAsync({
          startCTime: this.statInput.startDate,
          endCTime: this.statInput.endDate,
          statType: 1,
        })
        .then((result) => {
          this.shuju.series[0].data = [];
          for (var i = 1; i < result.columns.length - 1; i++) {
            var num = 0;
            for (var j = 0; j < result.data.length; j++) {
              num += result.data[j][result.columns[i]];
            }
            this.shuju.series[0].data.push({
              value: num,
              name: result.columns[i],
            });
          }
        }).catch(() => {

        })
        .finally(() => {
          this.loading1 = false;
        });

      ticketService
        .getRealTimeGroundTicketCheckOverview2Async(this.statInput)
        .then((result) => {
          this.shujub.xAxis[0].data = [];
          this.shujub.series[0].data = [];
          for (var i = 0; i < result.length; i++) {
            this.shujub.xAxis[0].data.push(result[i].groundname);
            this.shujub.series[0].data.push(result[i].checkinnum);
          }
        }).catch(() => {

        })
        .finally(() => {
          this.loading2 = false;
        });

      // Promise.all([shuju, shujub])
      //   .then(() => {

      //   })
      //   .catch(() => {

      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
        
    },
  },
  mounted() {},
  created() {
    this.loadData();
  },
};
</script>
<style scoped>

.loading{
  margin-top: 10px;
  text-align: center;
}
</style>
